import { ISwAppAccountStatementApi } from "../../interfaces-and-types";

type TAccountStatementUrls = {
  [key in keyof ISwAppAccountStatementApi]: string;
};

const rootAccountStatementUrl = "/account-statements";

export const accountStatementUrls: TAccountStatementUrls = {
  collectionsStatementCsv: `${rootAccountStatementUrl}/collections`,
  collectionsStatementPdf: `${rootAccountStatementUrl}/collections/pdf`,

  walletStatementCsv: `${rootAccountStatementUrl}/wallet`,
  walletStatementPdf: `${rootAccountStatementUrl}/wallet/pdf`,
};
